var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpeechBubblesPages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86 20.1V63C86 64.4852 85.41 65.9096 84.3598 66.9598C83.3096 68.01 81.8852 68.6 80.4 68.6H21.7L4 86.3V20.1C3.99977 18.6055 4.58656 17.1706 5.63398 16.1045C6.68141 15.0383 8.10566 14.4262 9.6 14.4H80.4C81.8943 14.4262 83.3186 15.0383 84.366 16.1045C85.4134 17.1706 86.0002 18.6055 86 20.1Z",
    fill: "#E9AF34",
    stroke: "#E9AF34",
    strokeWidth: 0.577422,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1 83.7V102.2C96.1 102.624 95.9315 103.031 95.6314 103.331C95.3313 103.631 94.9244 103.8 94.5 103.8H76.5C76.0757 103.8 75.6687 103.631 75.3687 103.331C75.0686 103.031 74.9 102.624 74.9 102.2V79.1C74.9255 78.6932 75.1052 78.3115 75.4026 78.0327C75.6999 77.754 76.0924 77.5992 76.5 77.6H90.2L96.1 83.7Z",
    fill: "#DB6C2F",
    stroke: "#DB6C2F",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3 34.5V53C37.3 53.2102 37.2586 53.4182 37.1782 53.6123C37.0978 53.8065 36.9799 53.9828 36.8313 54.1314C36.6828 54.28 36.5064 54.3978 36.3123 54.4783C36.1181 54.5587 35.9101 54.6 35.7 54.6H17.7C17.2756 54.6 16.8687 54.4315 16.5686 54.1314C16.2685 53.8314 16.1 53.4244 16.1 53V29.9C16.1 29.6899 16.1414 29.4819 16.2218 29.2878C16.3022 29.0936 16.42 28.9173 16.5686 28.7687C16.7172 28.6201 16.8936 28.5023 17.0877 28.4218C17.2818 28.3414 17.4899 28.3 17.7 28.3H31.4L37.3 34.5Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9 63.7001H140.4C141.885 63.7001 143.31 64.2901 144.36 65.3403C145.41 66.3905 146 67.8149 146 69.3001V135.6L128.3 117.9H69.5C68.0057 117.874 66.5814 117.262 65.534 116.196C64.4866 115.13 63.8998 113.695 63.9 112.2V76.3001",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45 51.3H63.2",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45 42.4H75.5",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M45 33.6H75.5",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M104.1 101H122.2",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M104.1 92.1H134.6",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M104.1 83.3H134.6",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3 34.4001H30.6V27.2001",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3 42.1H32.3",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3 47.3H29.2001",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M97.4 83.6H90.2V76.4",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M79 91.3H92",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M79 96.5H88.7",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeechBubblesPages);
export default __webpack_public_path__ + "static/media/speech_bubbles_pages.b86dfb5b217b48104db6dfbc92088c28.svg";
export { ForwardRef as ReactComponent };